<template>
    <div class="record-layout">
        <div class="patient-detail">
            <div>
                <div class="patient-details-wrapper--item">
                    <p class="patient-details-wrapper--item__heading">
                        {{ $t('modals.patint_form.name') }} {{ patient.firstName }} {{ patient.lastName }}
                    </p>
                </div>
            </div>
            <div class="patient-details-wrapper">
                <div class="patient-details-wrapper--item">
                    <p>{{ $t('modals.patint_form.date.title') }} {{ patient.dob }}</p>
                    <p class="patient-details-wrapper--item__info-icon">
                        <common-icon name="phone" size="small"></common-icon>
                        {{ patient.phone }}
                    </p>
                </div>
                <div v-if="patient.address" class="patient-details-wrapper--item patient-details-wrapper--item--location">
                    <p class="patient-details-wrapper--item--location__icon">
                        <common-icon name="location" size="huge"></common-icon>
                    </p>
                    <div>
                        <p>
                            {{ patient.address }}
                        </p>
                        <p>
                            {{ patient.zip }} {{ patient.city }}
                            {{ patient.state }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="patient-details-wrapper">
                <div class="patient-details-wrapper--item patient-details-wrapper--item--insurance">
                    <common-icon name="insurance" size="medium"></common-icon>
                    <div class="patient-details-wrapper--item--insurance__info">
                        <p>
                            <span class="patient-details-wrapper--item__heading">
                                {{ $t('modals.patint_form.primary.insurance') }}
                            </span>
                        </p>
                        <p>{{ insuranceName }}</p>
                        <p>{{ $t('modals.patint_form.group.title') }} {{ patient.groupNumber }}</p>
                        <p>{{ $t('modals.patint_form.id.title') }} {{ patient.insuranceId }}</p>
                    </div>
                </div>
                <div class="patient-details-wrapper--item patient-details-wrapper--item--insurance">
                    <div class="patient-details-wrapper--item--insurance__info">
                        <p class="patient-details-wrapper--item--avatar">
                            <span class="patient-details-wrapper--item__heading">
                                {{ $t('modals.patint_form.primary.care') }}
                            </span>
                        </p>
                        <p>{{ patient?.primaryCare?.name }}</p>
                        <p class="patient-details-wrapper--item__info-icon">
                            <common-icon name="email" size="small"></common-icon>
                            {{ patient?.primaryCare?.email }}
                        </p>
                        <p class="patient-details-wrapper--item__info-icon">
                            <common-icon name="phone" size="small"></common-icon>
                            {{ patient?.primaryCare?.phone }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <span class="patient-details-wrapper--item__heading">{{ $t('modals.patint_form.clinical.title') }}</span>
        </div>
        <div class="patient-details-wrapper patient-details-wrapper--history">
            <div
                class="patient-details-wrapper--item patient-details-wrapper--item__full-width patient-details-wrapper--item--insurance"
            >
                <common-icon name="calendar" size="medium"></common-icon>
                <div class="patient-details-wrapper--item--insurance__info">
                    <p>
                        <span class="patient-details-wrapper--item__heading">{{ patient?.history?.date }}</span>
                    </p>
                    <p>
                        {{ patient?.history?.diagnosis }}
                    </p>
                    <p v-if="patientRecords.length" class="patient-details-wrapper--item--insurance__info__images">
                        <span class="patient-details-wrapper--item__heading">
                            {{ $t('modals.patint_form.report') }}
                        </span>
                        <common-summary-item :isInline="false" :isCompact="false" width="full">
                            <common-images :images="patientRecords" :showMoreOption="true"></common-images>
                        </common-summary-item>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Store from '@/store'
    export default {
        props: {
            incomingPatient: { type: Object, required: true },
            patientRecords: { type: Array, required: false, default: () => [] },
        },

        data() {
            return {
                patient: {},
                insuranceName: '',
            }
        },

        methods: {
            loadData() {
                this.patient = {
                    firstName: this.incomingPatient.firstName || 'Not Available',
                    lastName: this.incomingPatient.lastName || 'Not Available',
                    dob: this.incomingPatient.dateOfBirth || 'Not Available',
                    phone: this.incomingPatient.mobilePhone || 'Not Available',
                    address: this.incomingPatient.address || 'Not Available',
                    city: this.incomingPatient.city,
                    state: this.incomingPatient.state,
                    zip: this.incomingPatient.zip,
                    groupNumber: this.incomingPatient.mcard?.groupNumber || 'Not Available',
                    insuranceId: this.incomingPatient.mcard?.memberId || 'Not Available',
                    patientInsuranceId: this.incomingPatient.mcard?.primaryInsuranceTypeId,
                    primaryCare: {
                        name: `${this.incomingPatient.mcard?.primaryCareProvider?.firstName || ''} ${
                            this.incomingPatient.mcard?.primaryCareProvider?.lastName || ''
                        }`,
                        email: this.incomingPatient.mcard?.primaryCareProvider?.email || 'Not Available',
                        phone: this.incomingPatient.mcard?.primaryCareProvider?.phone || 'Not Available',
                    },
                    history: {
                        date: this.incomingPatienthistory?.date || 'Not Available',
                        diagnosis: this.incomingPatienthistory?.diagnosis || 'Not Available',
                    },
                }
                if (this.patient.patientInsuranceId) {
                    this.getInsuranceName(this.patient.patientInsuranceId)
                }
            },

            async getInsuranceName(insuranceId) {
                const insuranceList = Store.getters['auth/getInsurancePlans']
                const insurance = insuranceList.find((item) => item.value === insuranceId)
                if (insurance) {
                    this.insuranceName = insurance.label
                } else {
                    this.insuranceName = 'Unknown'
                }
            },
        },

        mounted() {
            this.loadData()
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/components/page-elements/referrals/_referrals-patient-details-modal';
    .patient-details-wrapper {
        margin-top: 1.875rem;
    }
    .patient-detail {
        border-bottom: 1px solid #ddd;
    }
    .patient-details-wrapper--item--insurance__info__images {
        max-height: 500px;
        overflow-y: auto;
    }
</style>
